import { useAuth } from '@/auth/useAuth';
import { ABP_FEATURES } from '@/features/ai-assistant/constants';

/**
 * Whether AI is enabled for the current tenant.
 *
 * Every AI surface should hide behind this — not just the AI menu. The backend
 * refuses AI calls for a disabled tenant, so anything left visible is a button
 * that can only fail.
 *
 * Returns false until the ABP application-configuration response has landed, so
 * AI surfaces stay hidden rather than flashing into view and disappearing.
 */
export const useAiEnabled = (): boolean => {
  const { hasFeature, featuresLoaded } = useAuth();
  return featuresLoaded && hasFeature(ABP_FEATURES.AI_CAPABILITIES_ENABLED);
};
